import React from 'react';
import { BADGE_COLOR_CLASSES, BadgeColor } from '../utils/procurementEnums';

interface Props {
  label: string;
  color: BadgeColor;
  className?: string;
}

/**
 * Badge compacto reutilizável. Usa as classes Tailwind canônicas do Hub
 * (bg-{color}-500/20 text-{color}-400). Cores definidas em
 * `utils/procurementEnums.ts:BADGE_COLOR_CLASSES`.
 */
export function StatusBadge({ label, color, className = '' }: Props) {
  return (
    <span
      className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${BADGE_COLOR_CLASSES[color]} ${className}`}
    >
      {label}
    </span>
  );
}
